import { GetServerSideProps, NextPage } from 'next'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-requset'
import { MyContainer } from '~/components/ui/MyContainer'
import { Layout } from '~/layouts/default'
import {
  SingleCompetition,
  IAICompetitionContentObj,
  IAICompetitionDetailNode,
} from '~/components/pages/ai-competition/SingleCompetition'
import { Col, Row } from 'antd'
import { GET_COMPETITION_LIST } from '~/graphqls/gqls'
import {
  getCompetitionList,
  getCompetitionListVariables,
  getCompetitionList_marketingModule_competitionPage_edges_node,
} from '~/graphqls/types'
import { getGraphData } from '~/utils'
import { PAGE_SIZE } from '~/configs'

/** 字段格式化 */
function formatListRes(
  res?: getCompetitionList_marketingModule_competitionPage_edges_node | null
) {
  const contentObj: IAICompetitionContentObj =
    res?.content && JSON.parse(res?.content)
  return {
    node: {
      ...res,
      ...contentObj,
    },
  }
}

const AICompetitions: NextPage<{
  list: IAICompetitionDetailNode[]
}> = ({ list }) => {
  return (
    <Layout>
      <SEOHead title="AI创作大赛" />
      <MyContainer>
        <PageCrumbs dark title="AI创作大赛" />
        <Row gutter={32}>
          {list.map(item => (
            <Col span={12} key={item.id}>
              <SingleCompetition data={item} />
            </Col>
          ))}
        </Row>
      </MyContainer>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)

  const listRes = await client.query<
    getCompetitionList,
    getCompetitionListVariables
  >({
    query: GET_COMPETITION_LIST,
    variables: {
      offset: 0,
      first: PAGE_SIZE,
    },
    fetchPolicy: 'no-cache',
  })

  return {
    props: {
      initialState,
      list: getGraphData(
        listRes.data.marketingModule?.competitionPage?.edges?.map(it => ({
          ...formatListRes(it?.node),
        })) || []
      ),
    },
  }
}

export default AICompetitions
